<template>
  <div>
    <div>
      <v-data-table
        :headers="tableHeader"
        :items="tableData"
        class="elevation-1 v-table-middle-align"
        :single-select="false"
        show-select
        v-model="selectedCurrencies"
        :loading="isCurrencyDataLoading"
        disable-pagination
        :hide-default-footer="true"
        :item-class="rowActive"
      >
        <template v-slot:top>
          <div class="d-block d-sm-flex d-md-flex d-lg-flex pa-4">
            <div class="flex-grow-1">
              <p class="header-2 mb-0 pt-2">{{ $t("currencyname") }} - {{ $t('home_currency') }}: {{ homeCurrency }}</p>
            </div>
            <div class="d-sm-flex d-inline">
              <v-text-field
                v-model="searchText"
                :label="$t('dashboard_seach_placeholder')"
                prepend-inner-icon="mdi-magnify"
                clearable
                hide-details
                flat
                solo
                outlined
                dense
              ></v-text-field>
              <div class="ml-sm-2 ml-0 mt-2 mt-sm-0">
                <v-btn
                  class="form-border text-capitalize"
                  color="primary"
                  @click="onToggleCurrencyForm"
                  height="38"
                  block
                >
                  {{ $t("add_currency") }}
                </v-btn>
              </div>
            </div>
          </div>
          <v-divider />
        </template>
        <template v-slot:item.rate="{ item }">
          <h5>{{ item.rate.toFixed(item.precision) }}</h5>
        </template>
        <template v-slot:item.thousands_separator="{ item }">
          <h5 class="separator">{{ item.thousands_separator }}</h5>
        </template>
        <template v-slot:item.decimal_mark="{ item }">
          <h5 class="separator">{{ item.decimal_mark }}</h5>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                primary
                v-on="on"
                color="primary"
                text
                outlined
                small
              >
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item link @click="onSelectEditCurrencyData(item)">
                <v-list-item-title>{{ $t("edit") }}</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="onSelectCurrencyInformation(item)">
                <v-list-item-title>{{ $t("view") }}</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="onSelectCurrencyToDelete(item)">
                <v-list-item-title class="red--text">{{
                  $t("delete")
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:foot>
          <tfoot>
            <tr>
              <td colspan="12" class="text-right">
                <div class="d-none d-md-flex justify-center justify-sm-end">
                  <!-- <h6 class="text-subtitle-1 mt-2 labelcolor--text">{{pagination.current_page || 0}} - {{ pagination.total_pages || 0 }} {{ $t('of') }} {{ (pagination.total || 0).toLocaleString() }} <span class="d-sm-inline d-none">{{ $t('records') }}</span></h6> -->
                  <h6 class="text-subtitle-1 mt-2 labelcolor--text">
                    {{ (pagination.total || 0).toLocaleString() }}
                    <span class="">{{ $t("records") }}</span>
                  </h6>
                  <v-spacer />
                  <div class="select-page-limit">
                    <v-select
                      v-model="pageLimit"
                      :items="[10, 20, 25]"
                      label="Per page"
                      hide-details
                      dense
                      flat
                      solo
                      @change="onChangePageLimit"
                    ></v-select>
                  </div>
                  <pagination
                    :total="pagination.total_pages || 1"
                    :current-page="currentPage"
                    :total-visible="10"
                    @pageSelected="onPaginationClick"
                  >
                  </pagination>
                </div>
                <div class="d-block d-md-none">
                  <div class="d-flex align-center">
                    <h6 class="text-subtitle-1 mt-2 labelcolor--text">
                      {{ (pagination.total || 0).toLocaleString() }}
                      <span class="">{{ $t("records") }}</span>
                    </h6>
                    <v-spacer />
                    <div class="select-page-limit">
                      <v-select
                        v-model="pageLimit"
                        :items="[10, 20, 25]"
                        label="Per page"
                        hide-details
                        dense
                        flat
                        solo
                        @change="onChangePageLimit"
                      ></v-select>
                    </div>
                  </div>
                  <div>
                    <pagination
                      :total="pagination.total_pages || 1"
                      :current-page="currentPage"
                      :total-visible="10"
                      @pageSelected="onPaginationClick"
                    >
                    </pagination>
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </template>
      </v-data-table>
      <v-snackbar
        timeout="2000"
        vertical
        :color="snackbarOption.color"
        v-model="showSnackbar"
        bottom
      >
        <v-icon v-if="snackbarOption.icon">{{
          snackbarOption.icon
        }}</v-icon>
        {{ snackbarOption.message }}
      </v-snackbar>
    </div>
    <currency-form
      :open="showFormDialog"
      :is-edit-mode="isEditMode"
      :form-values="selectedCurrencyData"
      @toggle="onToggleCurrencyForm"
    ></currency-form>
    <currency-delete
      :open="showDeleteModal"
      :form-data="selectedDataToDelete"
      @toggle="onToggleDeleteCurrencyForm"
    ></currency-delete>
    <v-dialog
      v-model="showInfoModal"
      max-width="500"
      origin="top center"
      class="dialog pa-0"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar light elevation="1" class="">
            <v-toolbar-title>{{
              selectedCurrencyInformation.name
            }}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn
              class="d-none d-sm-flex"
              color="primary"
              @click="onSelectEditCurrencyData(selectedCurrencyInformation)"
            >
              {{ $t("Edit") }}
            </v-btn>
            <v-btn
              text
              outlined
              class="ml-1 mr-4 d-none d-sm-flex"
              @click="onSelectCurrencyToDelete(selectedCurrencyInformation)"
            >
              {{ $t("delete") }}
            </v-btn>
            <v-btn
              icon
              class="d-none d-sm-flex"
              @click="onToggleCurrencyInformationModal"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="py-4 pb-8">
          <v-row
            no-gutters
            v-for="item in tableHeader"
            :key="item.text"
            class="row-stripe py-2 px-1"
          >
            <v-col cols="6" class="text-left ">
              <h5 class="labelcolor--text">{{ item.text }}</h5>
            </v-col>
            <v-col cols="6" class="text-left">
              <h5>{{ selectedCurrencyInformation[item.value] }}</h5>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { apiErrorMessage, debounce } from "@/utils/general";
import Pagination from "../components/Pagination.vue";
import CurrencyForm from "../components/CurrencyForm.vue";
import CurrencyDelete from "../components/CurrencyDeleteModal.vue";
export default {
  components: {
    Pagination,
    CurrencyForm,
    CurrencyDelete,
  },
  data() {
    return {
      isCurrencyDataLoading: false,
      selectedCurrencies: [],
      currencyLists: [],
      selectedCurrencyData: {},
      page: 1,
      currentPage: 1,
      pageLimit: 10,
      searchText: "",
      isEditMode: false,
      showFormDialog: false,
      showSnackbar: false,
      snackbarOption: {
        icon: "",
        message: "",
        color: "",
      },
      showDeleteModal: false,
      selectedDataToDelete: {},
      showInfoModal: false,
      selectedCurrencyInformation: {},
    };
  },
  watch: {
    searchText: debounce(function () {
      this.fetchCurrencyData();
    }, 300)
  },
  methods: {
    ...mapActions("accounting", ["getAccountingCurrencies"]),

    onSelectCurrencyInformation(data) {
      this.selectedCurrencyInformation = data;
      this.onToggleCurrencyInformationModal();
    },

    onToggleCurrencyInformationModal() {
      this.showInfoModal = !this.showInfoModal;
      if (!this.showInfoModal) {
        this.selectedCurrencyInformation = {};
      }
    },
    onToggleCurrencyForm(options = {}) {
      this.isEditMode = false;
      // this.selectedServiceData = {};
      this.showFormDialog = !this.showFormDialog;
      if (options.created || options.updated) {
        this.snackbarOption = {
          icon: "mdi-check",
          color: "success",
          message: options.message,
        };
        this.showSnackbar = true;
        this.showInfoModal = false;
        this.fetchCurrencyData();
      }
    },

    onSelectCurrencyToDelete(data = {}) {
      this.selectedDataToDelete = JSON.parse(JSON.stringify(data));
      this.onToggleDeleteCurrencyForm();
    },

    onToggleDeleteCurrencyForm(options = {}) {
      this.showDeleteModal = !this.showDeleteModal;

      if (options.deleted) {
        this.snackbarOption = {
          icon: "mdi-delete",
          color: "red",
          message: options.message || "Deleted.",
        };
        this.showSnackbar = true;
        this.showInfoModal = false;

        this.fetchCurrencyData();
      }
    },

    onSelectEditCurrencyData(data = {}) {
      this.selectedCurrencyData = JSON.parse(JSON.stringify(data));
      this.isEditMode = true;
      this.showFormDialog = true;
    },

    onPaginationClick(pageNumber) {
      this.currentPage = pageNumber;
      this.fetchCurrencyData();
    },

    onChangePageLimit() {
      this.currentPage = 1;
      this.fetchCurrencyData();
    },
    async fetchCurrencyData() {
      if (this.isCurrencyDataLoading) {
        return;
      }
      this.isCurrencyDataLoading = true;
      try {
        const data = await this.getAccountingCurrencies({
          page: this.currentPage,
          limit: this.pageLimit,
          search: this.searchText || "",
        });
        this.currencyLists = data;
        this.isCurrencyDataLoading = false;
      } catch (error) {
        this.isCurrencyDataLoading = false;
        apiErrorMessage(error);
      }
    },

		rowActive(item){
			const { id } = this.selectedCurrencyInformation
			if( item.id === id ){
				return 'cyan lighten-4';
			}
			return null;
		},

  },
  created() {
    this.fetchCurrencyData();
  },
  computed: {
    ...mapGetters('accounting', ['homeCurrency']),
    tableData: {
      get() {
        return this.currencyLists?.data || [];
      },
    },

    pagination: {
      get() {
        return this.currencyLists.data
          ? this.currencyLists.meta.pagination
          : {};
      },
    },

    tableHeader() {
      return [
        {
          text: this.$t("code"),
          value: "code",
          class: "text-uppercase th--text font-weight-bold",
          align: "center",
        },
        {
          text: this.$t("currency_name_header"),
          value: "name",
          class: "text-uppercase th--text font-weight-bold",
          align: "center",
        },
        {
          text: this.$t("symbol"),
          value: "symbol",
          class: "text-uppercase th--text font-weight-bold",
          align: "center",
        },
        {
          text: this.$t("symbol_position"),
          value: "symbol_first",
          class: "text-uppercase th--text font-weight-bold",
          align: "center",
        },
        {
          text: this.$t("precision"),
          value: "precision",
          class: "text-uppercase th--text font-weight-bold",
          align: "center",
        },
        {
          text: this.$t("rate"),
          value: "rate",
          class: "text-uppercase th--text font-weight-bold",
          align: "center",
        },
        {
          text: this.$t("thousands_separator"),
          value: "thousands_separator",
          class: "text-uppercase th--text font-weight-bold",
          align: "center",
        },
        {
          text: this.$t("decimal_mark"),
          value: "decimal_mark",
          class: "text-uppercase th--text font-weight-bold",
          align: "center",
        },
        {
          text: this.$t("default_currency"),
          value: "default_currency",
          class: "text-uppercase th--text font-weight-bold",
          align: "center",
        },
        { text: "", value: "actions", sortable: false },
      ];
    },

  },
};
</script>
<style lang="scss" scoped>
.vue-app {
  background: none;
}

.v-tabs {
  border-bottom: 1px solid #ddd;

  .v-tab {
    color: #0889a0;
  }
}
/* .separator {
  font-size: 1.5rem;
  font-weight: bold;
} */
.container {
  background-color: none;
}

.w-100 {
  width: 100%;
}

.v-list-item {
  min-height: 36px;
}
.row-stripe:nth-child(odd) {
  background-color: rgb(243, 243, 243);
}
.dialog {
  z-index: 9999;
}
</style>
<style lang="scss">
.v-table-middle-align {
  td,
  th {
    vertical-align: middle !important;
  }
}
.select-page-limit {
  width: 80px;
}
</style>